import AnalyticsVendor from './AnalyticsVendor';

const getApplication = (platform = 'web'): string => {
  try {
    // Need navigator to catch Safari PWA. But TS don't like.
    const navigator: any = window.navigator;
    if (
      window.matchMedia('(display-mode: standalone)').matches ||
      navigator.standalone === true
    ) {
      return 'PWA';
    }
  } catch (e) {
    console.log('Analytics getApplication error', e);
  }
  return platform;
};

const COLLECTOR_NAME = 'fivetran';
const COLLECTOR_URI = `i12qs6f8ef.execute-api.us-west-1.amazonaws.com/event-transformer/mono?ignore=`;
const schema = 'iglu:com.snowplowanalytics.iglu/anything-a/jsonschema/1-0-0';
const USER_ID_COOKIE = '_sws_uid';

class Fivetran extends AnalyticsVendor {
  public enabled: boolean;
  constructor(platform: string) {
    super();
    this.enabled = true;
    if (typeof window['snowplow'] === 'function') {
      console.log('Snowplow has registered on window object.');

      const TRACKER_OPTIONS = {
        // Initialise a tracker
        appId: getApplication(platform),
        platform,
        cookieName: '_sws_',
        encodeBase64: false,
        post: true,
        discoverRootDomain: true,
        forceSecureTracker: true,
      };

      window['snowplow'](
        'newTracker',
        COLLECTOR_NAME,
        COLLECTOR_URI,
        TRACKER_OPTIONS
      );
      window['snowplow']('setUserIdFromCookie', USER_ID_COOKIE);
    } else {
      NODE_ENV === 'production' &&
        console.error('Snowplow is not registered on window object..');
    }
  }

  test() {
    return typeof window['snowplow'] === 'function';
  }

  identify(userId: string) {
    try {
      if (typeof window['snowplow'] === 'function') {
        document.cookie = `${USER_ID_COOKIE}=${userId}; expires=Fri, 31 Dec 9999 23:59:59 GMT;domain=.simplywall.st;path=/`;
        window['snowplow']('setUserId', userId);
        console.log('Snowplow setUserId', userId);
      } else {
        console.warn('Snowplow is not registered on window object..');
      }
    } catch (error) {
      console.error('Error setting identity in snowplow tracker..', error);
    }
  }

  track(event: string, eventProperties: Record<string, unknown>) {
    try {
      if (typeof window['snowplow'] === 'function') {
        const data = Object.assign(
          {
            event,
          },
          eventProperties
        );
        window['snowplow'](`trackSelfDescribingEvent:${COLLECTOR_NAME}`, {
          schema,
          data,
        });
        console.log('Snowplow trackSelfDescribingEvent', schema, data);
      } else {
        console.warn('Snowplow is not registered on window object..');
      }
    } catch (error) {
      console.error('Error tracking action in snowplow tracker..', error);
    }
  }

  page(pathname: string) {
    try {
      if (typeof window['snowplow'] === 'function') {
        window['snowplow']('trackPageView');
        console.log('Snowplow trackPageView', pathname);
      } else {
        console.warn('Snowplow is not registered on window object..');
      }
    } catch (error) {
      console.error('Error tracking pageview in snowplow tracker..', error);
    }
  }
}

export default Fivetran;
